import { handleInvalidEventProps } from 'src/dataLayer/remoteData/babbelEventStream/validateEventProps'

import declareEvent from './declareEvent'
import declareEventResetPassword from './declareEventResetPassword'

const PAGE_SHOWN_EVENT_NAME = 'authentication_page:shown'
const PAGE_SHOWN_EVENT_VERSION = 3
const AUTHENTICATION_RESET_PASSWORD_EVENT_NAME = 'password_authentication:reset_password'
const AUTHENTICATION_RESET_PASSWORD_EVENT_VERSION = 1

const trackGuiInteracted = declareEvent({
  getCalltimePayload: ({ guiElementName }) => ({ gui_element: guiElementName }),
  name: 'gui:interacted',
  version: 2,
})

const trackPageShown = declareEvent({
  getCalltimePayload: ({ appType, pageType }) => {
    if (!appType || !pageType) {
      handleInvalidEventProps({
        appType,
        name: PAGE_SHOWN_EVENT_NAME,
        pageType,
        version: PAGE_SHOWN_EVENT_VERSION,
      })
    }
    return { page_name: `${appType}:${pageType}` }
  },
  name: PAGE_SHOWN_EVENT_NAME,
  version: PAGE_SHOWN_EVENT_VERSION,
})

const trackPerformance = declareEvent({
  getCalltimePayload: ({
    connectEnd,
    connectStart,
    domainLookupEnd,
    domainLookupStart,
    domComplete,
    domContentLoadedEventEnd,
    domContentLoadedEventStart,
    domInteractive,
    domLoading,
    fetchStart,
    loadEventEnd,
    loadEventStart,
    navigationStart,
    redirectEnd,
    redirectStart,
    requestStart,
    responseEnd,
    responseStart,
    secureConnectionStart,
    unloadEventEnd,
    unloadEventStart,
  }) => ({
    connect_end: connectEnd,
    connect_start: connectStart,
    dom_complete: domComplete,
    dom_content_loaded_event_end: domContentLoadedEventEnd,
    dom_content_loaded_event_start: domContentLoadedEventStart,
    dom_interactive: domInteractive,
    dom_loading: domLoading,
    domain_lookup_end: domainLookupEnd,
    domain_lookup_start: domainLookupStart,
    fetch_start: fetchStart,
    load_event_end: loadEventEnd,
    load_event_start: loadEventStart,
    navigation_start: navigationStart,
    redirect_end: redirectEnd,
    redirect_start: redirectStart,
    request_start: requestStart,
    response_end: responseEnd,
    response_start: responseStart,
    secure_connection_start: secureConnectionStart,
    unload_event_end: unloadEventEnd,
    unload_event_start: unloadEventStart,
  }),
  name: 'performance:page_loaded',
  version: 2,
})

const trackAuthenticationResetPassword = declareEventResetPassword({
  getCalltimePayload: ({ stage }) => ({
    blocked: false,
    created_at: new Date().toISOString(),
    stage,
  }),
  name: AUTHENTICATION_RESET_PASSWORD_EVENT_NAME,
  version: AUTHENTICATION_RESET_PASSWORD_EVENT_VERSION,
})

export { trackAuthenticationResetPassword, trackGuiInteracted, trackPageShown, trackPerformance }
